export default __webpack_public_path__ + "static/Unionmon2-4de4b06e4df327832ce41c27db23146e.png";